const hotKeys: KeyType = {
  0: 48,
  1: 49,
  2: 50,
  3: 51,
  4: 52,
  5: 53,
  6: 54,
  7: 55,
  8: 56,
  9: 57,
  a: 65,
  b: 66,
  c: 67,
  d: 68,
  e: 69,
  f: 70,
  g: 71,
  h: 72,
  i: 73,
  j: 74,
  k: 75,
  l: 76,
  m: 77,
  n: 78,
  o: 79,
  p: 80,
  q: 81,
  r: 82,
  s: 83,
  t: 84,
  u: 85,
  v: 86,
  w: 87,
  x: 88,
  y: 89,
  z: 90,
  backspace: 8,
  tab: 9,
  enter: 13,
  alt: 18,
  esc: 27,
  leftArrow: 37,
  upArrow: 38,
  rightArrow: 39,
  downArrow: 40,
  insert: 45,
  delete: 46,
  bracketLeft: 219,
  bracketRight: 221,
  comma: 188,
  period: 190,
  slash: 191,
  backslash: 220,
  space: 32,
};

export type KeyType = {
  0: number;
  1: number;
  2: number;
  3: number;
  4: number;
  5: number;
  6: number;
  7: number;
  8: number;
  9: number;
  a: number;
  b: number;
  c: number;
  d: number;
  e: number;
  f: number;
  g: number;
  h: number;
  i: number;
  j: number;
  k: number;
  l: number;
  m: number;
  n: number;
  o: number;
  p: number;
  q: number;
  r: number;
  s: number;
  t: number;
  u: number;
  v: number;
  w: number;
  x: number;
  y: number;
  z: number;
  backspace: number;
  tab: number;
  enter: number;
  alt: number;
  esc: number;
  leftArrow: number;
  upArrow: number;
  rightArrow: number;
  downArrow: number;
  insert: number;
  delete: number;
  bracketLeft: number;
  bracketRight: number;
  comma: number;
  period: number;
  slash: number;
  backslash: number;
  space: number;
};

const hotKeyConverter = (key: keyof KeyType): number => {
  return hotKeys[key];
};

export default hotKeyConverter;
